import {
  USER_GET_DATA,
  USER_GET_DATA_SUCCESS,
  USER_GET_DATA_ERROR,
  USER_EDIT_ITEM,
  USER_EDIT_ITEM_SUCCESS,
  USER_EDIT_ITEM_ERROR,
  USER_AVATAR_EDIT_ITEM,
  USER_AVATAR_EDIT_ITEM_SUCCESS,
  USER_AVATAR_EDIT_ITEM_ERROR,
  USER_GET_AVATAR,
  USER_GET_AVATAR_SUCCESS,
  USER_GET_AVATAR_ERROR,
  USER_REMOVE_ITEM,
  USER_REMOVE_ITEM_SUCCESS,
  USER_REMOVE_ITEM_ERROR,
  USER_VALIDATE_ITEM,
  USER_VALIDATE_ITEM_SUCCESS,
  USER_VALIDATE_ITEM_ERROR,
  USER_ADMIN_EDIT_ITEM,
  USER_ADMIN_EDIT_ITEM_SUCCESS,
  USER_ADMIN_EDIT_ITEM_ERROR,
  USER_CLEAR_DATA,
} from "../actions";

//* GET DATA LOGGED USER  -----------------------------------------------------------------------------
export const getUserData = (payload) => {
  // console.log("inside Action", payload);

  return {
    type: USER_GET_DATA,
    payload: payload,
  };
};

export const getUserDataSuccess = (items) => {
  //console.log(items);
  return { type: USER_GET_DATA_SUCCESS, payload: items };
};

export const getUserDataError = (error) => ({
  type: USER_GET_DATA_ERROR,
  payload: error,
});

//* EDIT LOGGED USER ---------------------------------------------------------------------------------
export const editUserItem = (item) => ({
  type: USER_EDIT_ITEM,
  payload: item,
});

export const editUserItemSuccess = (items) => {
  // console.log(items);

  return {
    type: USER_EDIT_ITEM_SUCCESS,
    payload: items,
  };
};

export const editUserItemError = (error) => {
  //console.log(error);
  return {
    type: USER_EDIT_ITEM_ERROR,
    payload: error,
  };
};

//* GET AVATAR LOGGED USER  ---------------------------------------------------------------------------
export const getUserAvatar = (item) => {
  // console.log("inside get avatar action");
  return {
    type: USER_GET_AVATAR,
    payload: item,
  };
};

export const getUserAvatarSuccess = (items) => {
  // console.log(items);

  return {
    type: USER_GET_AVATAR_SUCCESS,
    payload: items,
  };
};

export const getUserAvatarError = (error) => {
  // console.log(error);
  return {
    type: USER_GET_AVATAR_ERROR,
    payload: error,
  };
};

//* EDIT AVATAR LOGGED USER   -----------------------------------------------------------------------------
export const editUserAvatarItem = (item) => {
  // console.log("inside avatar action");
  return {
    type: USER_AVATAR_EDIT_ITEM,
    payload: item,
  };
};

export const editUserAvatarItemSuccess = (items) => {
  // console.log(items);

  return {
    type: USER_AVATAR_EDIT_ITEM_SUCCESS,
    payload: items,
  };
};

export const editUserAvatarItemError = (error) => {
  // console.log(error);
  return {
    type: USER_AVATAR_EDIT_ITEM_ERROR,
    payload: error,
  };
};

//* REMOVE LOGGED USER // ---------------------------------------------------------------------------------------------
export const removeUserItem = (item) => ({
  type: USER_REMOVE_ITEM,
  payload: item,
});

export const removeUserItemSuccess = (items) => {
  console.log("removeUserItemSuccess", items);

  return {
    type: USER_REMOVE_ITEM_SUCCESS,
    payload: items,
  };
};

export const removeUserItemError = (error) => {
  console.log(error);
  return {
    type: USER_REMOVE_ITEM_ERROR,
    payload: error,
  };
};

//* VALIDATE USER (SUPER ADMIN)// ---------------------------------------------------------------------------------------------
export const validateUserItem = (item) => ({
  type: USER_VALIDATE_ITEM,
  payload: item,
});

export const validateUserItemSuccess = (items) => {
  console.log("validateUserItemSuccess", items);

  return {
    type: USER_VALIDATE_ITEM_SUCCESS,
    payload: items,
  };
};

export const validateUserItemError = (error) => {
  console.log(error);
  return {
    type: USER_VALIDATE_ITEM_ERROR,
    payload: error,
  };
};

//* EDIT ADMIN USER (promoting to admin and edit managed user) (SUPER ADMIN)  ---------------------------------------------------------------------------------
export const editUserAdminItem = (item) => ({
  type: USER_ADMIN_EDIT_ITEM,
  payload: item,
});

export const editUserAdminItemSuccess = (items) => {
  // console.log(items);

  return {
    type: USER_ADMIN_EDIT_ITEM_SUCCESS,
    payload: items,
  };
};

export const editUserAdminItemError = (error) => {
  //console.log(error);
  return {
    type: USER_ADMIN_EDIT_ITEM_ERROR,
    payload: error,
  };
};

//* CLEAR DATA LOGGED USER // ---------------------------------------------------------------------------------------------
// clearing redux state at logout
export const clearUserData = (history) => {
  return {
    type: USER_CLEAR_DATA,
    payload: { history },
  };
};
